export const TEST_ID = 'droneIcon';
